export default "__VITE_ASSET__BLSCCf6T__"